var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownSelect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.516,
    height: 9.147,
    viewBox: "0 0 15.516 9.147"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.675,8.472l7.044,7.044,1.428-1.428-6.31-6.33,6.31-6.33L7.719,0,.675,7.044,0,7.758Z",
    transform: "translate(0 9.147) rotate(-90)"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNS41MTYiIGhlaWdodD0iOS4xNDciIHZpZXdCb3g9IjAgMCAxNS41MTYgOS4xNDciPjxwYXRoIGQ9Ik0uNjc1LDguNDcybDcuMDQ0LDcuMDQ0LDEuNDI4LTEuNDI4LTYuMzEtNi4zMyw2LjMxLTYuMzNMNy43MTksMCwuNjc1LDcuMDQ0LDAsNy43NThaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDkuMTQ3KSByb3RhdGUoLTkwKSIvPjwvc3ZnPg==";
export { SvgArrowDownSelect as ReactComponent };